import { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header.tsx";
import Home from "./pages/Home.tsx";
import Order from "./pages/Order.tsx";
import Confirmation from "./pages/Confirmation.tsx";
import Login from "./pages/admin/Login.tsx";
import Dashboard from "./pages/admin/Dashboard.tsx";
import Products from "./pages/admin/Products.tsx";
import Settings from "./pages/admin/Settings.tsx";
import Footer from "./components/Footer.tsx";
import { CartProvider } from "./context/CartContext.tsx";
import { AuthProvider } from "./context/AuthContext.tsx";
import "./App.css";

// Composant pour scroll vers le haut lors du changement de route
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

import LoadingScreen from "./components/LoadingScreen.tsx";

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <Router>
          <ScrollToTop />
          <LoadingScreen />
          <div className="App">
            <Routes>
              {/* Routes publiques */}
              <Route
                path="/"
                element={
                  <>
                    <Header />
                    <Home />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/order"
                element={
                  <>
                    <Header />
                    <Order />
                    <Footer />
                  </>
                }
              />
              <Route
                path="/confirmation"
                element={
                  <>
                    <Header />
                    <Confirmation />
                    <Footer />
                  </>
                }
              />

              {/* Routes admin */}
              <Route path="/admin" element={<Login />} />
              <Route path="/admin/dashboard" element={<Dashboard />} />
              <Route path="/admin/products" element={<Products />} />
              <Route path="/admin/settings" element={<Settings />} />
            </Routes>
          </div>
        </Router>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
